import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'view-cell',
  template: `<span><i class="fa fa-eye" (click)="invokeParentMethod();" style="width:100%;"></i></span>`,
  styles: [
      `.btn {
      line-height: 0.5
    }`
  ]
})

export class ViewChildRendered implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.params.context.view(this.params);
  }

  refresh(): boolean {
    return false;
  }
}
